<template>
  <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  <div>
    <el-form :inline="true" :model="form">
      <el-form-item label="明文">
        <el-input v-model="form.decrypt" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="encrypt">加密</el-button>
      </el-form-item>
    </el-form>

    <el-form :inline="true" :model="form">
      <el-form-item label="密文">
        <el-input v-model="form.encrypt" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="decrypt">解密</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
// import HelloWorld from './components/HelloWorld.vue'



import { ref, inject } from 'vue'
const cryoptojs = inject('cryptojs')

const form = ref({})
const encrypt = () => {
  form.value.encrypt = cryoptojs.AES.encrypt(form.value.decrypt, "njcsrjigjtihycscs").toString()
}
const decrypt = () => {
  form.value.decrypt = cryoptojs.AES.decrypt(form.value.encrypt, "njcsrjigjtihycscs").toString(cryoptojs.enc.Utf8)
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
